import React, { useState, useEffect } from 'react';
import Facturar from 'views/Facturacion/FacturaModal';
import TransaccionDetails from './DetallePagos';
import {
  Box,
  Button,
  Heading,
  Text,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Divider,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  ModalFooter,
  Tabs,
  TabPanels,
  TabPanel,
  useDisclosure,
  useToast,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Spinner,
} from '@chakra-ui/react';
import axios from 'axios';
import { ChevronDownIcon } from '@chakra-ui/icons';

interface Pago {
  id: string;
  fechaPago: string;
  monto: number;
  tipoPago: string;
  estado: string;
  UUID: string;
  estatus_de_cancelacion:string;
  RFCReceptor: string;
}

interface HistorialPagosProps {
  idClaveCatastral: string;
  idPredioSys: string;
  data: any;
}

const HistorialPagos: React.FC<HistorialPagosProps> = ({
  idClaveCatastral,
  idPredioSys,
  data,
}) => {
  const [pagosPredio, setPagosPredio] = useState<Pago[]>([]);
  const [selectedPagoId, setSelectedPagoId] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [loading, setLoading] = useState(false); // Estado para bloquear pantalla

  const toast = useToast();

  const {
    isOpen: isDetailOpen,
    onOpen: onDetailOpen,
    onClose: onDetailClose,
  } = useDisclosure();

  useEffect(() => {
    const fetchPagosPredio = async () => {
      setIsLoading(true);
      try {
        const response = await axios.get(
          `http://52.91.130.91:5000/api/Transacciones/${idClaveCatastral}`,
        );
        const data = response.data;

        const formattedPagos = data.map((item: any) => ({
          id: item.ID.toString(),
          fechaPago: item.Fecha
            ? new Date(item.Fecha).toISOString()
            : 'Sin Fecha',
          monto: item.Monto,
          tipoPago: item.Concepto,
          UUID: item.UUID,
          estado: item.Fecha ? 'Pagado' : 'Pagado',
          estatus_de_cancelacion:item.estatus_de_cancelacion
        }));

        setPagosPredio(formattedPagos);
      } catch (error) {
        console.error('Error al obtener los pagos de predio:', error);
        toast({
          title: 'Error',
          description: 'No se pudieron cargar los pagos de predio.',
          status: 'error',
          duration: 3000,
          isClosable: true,
        });
      } finally {
        setIsLoading(false);
      }
    };

    fetchPagosPredio();
  }, [idClaveCatastral, toast]);

  const handleVerDetalle = (pagoId: string) => {
    setSelectedPagoId(pagoId);
    onDetailOpen();
  };

  return (
    <Box
      p={8}
      bg="gray.50"
      borderRadius="md"
      boxShadow="md"
      maxW="1280px"
      mx="auto"
      mt={8}
    >  {loading && (
      <Box
        position="fixed"
        top="0"
        left="0"
        width="100vw"
        height="100vh"
        bg="rgba(0, 0, 0, 0.5)"
        display="flex"
        justifyContent="center"
        alignItems="center"
        zIndex="9999"
      >
        <Spinner size="xl" color="white" />
      </Box>
    )}
      
      <Heading as="h1" size="lg" color="teal.500" mb={6} textAlign="center">
        Historial de Pagos de Predio
      </Heading>
      <Divider mb={4} />

      <Tabs isFitted variant="enclosed">
        <TabPanels>
          <TabPanel>
            {isLoading ? (
              <Text>Cargando pagos de predio...</Text>
            ) : (
              <Box overflowX="auto" maxHeight="350px" overflowY="auto">
                <Table variant="simple" size="md">
                  <Thead>
                    <Tr>
                      <Th>ID</Th>
                      <Th>Fecha de Pago</Th>
                      <Th>Monto</Th>
                      <Th>Tipo de Pago</Th>
                      <Th>Estado</Th>
                      <Th>UUID</Th>
                      <Th>Cancelado?</Th>
                      <Th>Acciones</Th>
                    </Tr>
                  </Thead>
                  <Tbody>
                    {pagosPredio.length > 0 ? (
                      pagosPredio.map((pago) => (
                        <Tr
                        key={pago.id}
                        bgColor={pago.estatus_de_cancelacion === 'CANCELADO' ? 'red.300' : 'transparent'}
                      fontSize={'sm'}
                      >
                          <Td>{pago.id}</Td>
                          <Td>
                            {pago.fechaPago === 'Sin Fecha'
                              ? pago.fechaPago
                              : new Date(pago.fechaPago).toLocaleDateString()}
                          </Td>
                          <Td>
                            $
                            {new Intl.NumberFormat('en-US', {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            }).format(pago.monto)}
                          </Td>
                          <Td>{pago.tipoPago}</Td>
                          <Td
                            color={
                              pago.estado === 'Pendiente'
                                ? 'orange.500'
                                : 'green.500'
                            }
                          >
                            {pago.estado}
                          </Td>
                          <Td>{pago.UUID || 'N/A'}</Td>
                          <Td>{pago.estatus_de_cancelacion}</Td>

                          <Td>
                            <Menu>
                              <MenuButton
                                as={Button}
                                size="sm"
                                colorScheme="teal"
                                rightIcon={<ChevronDownIcon />}
                              >
                                Opciones
                              </MenuButton>
                              <MenuList>
                                {pago.UUID === null ? (
                                  <MenuItem
                                    onClick={async () => {
                                      try {
                                        const response = await axios.get(
                                          `http://52.91.130.91:5000/api/Facturacion/generarx-prod/${pago.id}`,
                                          {
                                            responseType: 'blob',
                                          },
                                        );

                                        const xmlBlob = new Blob(
                                          [response.data],
                                          {
                                            type: 'application/xml',
                                          },
                                        );
                                        const xmlUrl =
                                          URL.createObjectURL(xmlBlob);

                                        const link =
                                          document.createElement('a');
                                        link.href = xmlUrl;
                                        link.setAttribute(
                                          'download',
                                          `CFDI_${pago.id}.xml`,
                                        );
                                        document.body.appendChild(link);
                                        link.click();
                                        document.body.removeChild(link);

                                        toast({
                                          title: 'Éxito',
                                          description:
                                            'CFDI generado y descargado correctamente.',
                                          status: 'success',
                                          duration: 5000,
                                          isClosable: true,
                                        });
                                      } catch (error) {
                                        console.error(
                                          'Error al generar el CFDI:',
                                          error,
                                        );
                                        toast({
                                          title: 'Error',
                                          description:
                                            'No se pudo generar el CFDI. Intenta de nuevo.',
                                          status: 'error',
                                          duration: 5000,
                                          isClosable: true,
                                        });
                                      }
                                    }}
                                  >
                                    Facturar
                                  </MenuItem>
                                ) : (
                                  <MenuItem
                                    onClick={async () => {
                                      setLoading(true); // Activa el bloqueo de pantalla

                                      try {
                                        const response = await axios.get(
                                          `http://52.91.130.91:5000/api/Transacciones/Imprimir/` +
                                            pago.id,
                                          {
                                            responseType: 'blob',
                                          },
                                        );

                                        const pdfBlob = new Blob(
                                          [response.data],
                                          {
                                            type: 'application/pdf',
                                          },
                                        );
                                        const pdfUrl =
                                          URL.createObjectURL(pdfBlob);
                                          window.open(pdfUrl, '_blank');

                                        // const link =
                                        //   document.createElement('a');
                                        // link.href = pdfUrl;
                                        // link.setAttribute(
                                        //   'download',
                                        //   `CFDI_${pago.UUID}.pdf`,
                                        // );
                                        // document.body.appendChild(link);
                                        // link.click();
                                        // document.body.removeChild(link);

                                        toast({
                                          title: 'Éxito',
                                          description:
                                            'CFDI descargado correctamente.',
                                          status: 'success',
                                          duration: 5000,
                                          isClosable: true,
                                        });
                                      } catch (error) {
                                        console.error(
                                          'Error al descargar el CFDI:',
                                          error,
                                        );
                                        toast({
                                          title: 'Error',
                                          description:
                                            'No se pudo descargar el CFDI. Intenta de nuevo.',
                                          status: 'error',
                                          duration: 5000,
                                          isClosable: true,
                                        });
                                      } finally {
                                        setLoading(false)
                                      }
                                    }}
                                  >
                                    Imprimir CFDI
                                  </MenuItem>
                                )}
                                <MenuItem
                                  onClick={() => handleVerDetalle(pago.id)}
                                >
                                  Ver Detalle
                                </MenuItem>
                                <MenuItem
  onClick={() => {
    const downloadUrl = `http://52.91.130.91:5000/api/Facturacion/descargar/${pago.UUID}`;
    window.open(downloadUrl, '_blank');
  }}
>
  Descargar XML
</MenuItem>

                                <MenuItem
                                  onClick={async () => {
                                    let toastId; // Identificador para el toast
                                    try {
                                      // Mostrar un toast indicando que se está procesando la cancelación
                                      toastId = toast({
                                        title: 'Procesando',
                                        description:
                                          'La cancelación del CFDI está en curso, espera un momento.',
                                        status: 'info',
                                        duration: null, // El toast permanece visible hasta que lo cierres manualmente
                                        isClosable: true,
                                      });

                                      // Datos requeridos por el backend
                                      const requestData = {
                                        user: 'usuario_desde_bd',
                                        pass: 'password_desde_bd',
                                        rfcEmisor: 'RFC_desde_bd',
                                        listaCFDI: [
                                          {
                                            EsCancelable: true, // Supón que el CFDI es cancelable
                                            FolioSustitucion: '', // Si aplica, puedes incluirlo
                                            Motivo: '03', // Motivo de cancelación: "No se llevó a cabo la operación"
                                            RFCReceptor:
                                              pago.RFCReceptor ||
                                              'XAXX010101000',
                                            Total: pago.monto,
                                            UUID: pago.UUID, // UUID del CFDI que se desea cancelar
                                          },
                                        ],
                                      };

                                      // Realizar la solicitud POST al backend
                                      const response = await axios.post(
                                        'http://52.91.130.91:5000/api/Facturacion/cancelar-cfdi',
                                        requestData,
                                        { responseType: 'blob' }, // Asegúrate de recibir el archivo como blob
                                      );

                                      if (response.data) {
                                        // Crear un blob a partir del XML
                                        const xmlBlob = new Blob(
                                          [response.data],
                                          { type: 'application/xml' },
                                        );

                                        // Crear un enlace para descargar el archivo
                                        const xmlUrl =
                                          URL.createObjectURL(xmlBlob);
                                        const link =
                                          document.createElement('a');
                                        link.href = xmlUrl;
                                        link.setAttribute(
                                          'download',
                                          `Cancelacion_CFDI_${pago.UUID}.xml`,
                                        );

                                        // Simular clic en el enlace para iniciar la descarga
                                        document.body.appendChild(link);
                                        link.click();
                                        document.body.removeChild(link);

                                        // Cerrar el toast de progreso y mostrar uno de éxito
                                        toast.close(toastId);
                                        toast({
                                          title: 'Éxito',
                                          description:
                                            'El CFDI fue cancelado y el XML se descargó correctamente.',
                                          status: 'success',
                                          duration: 5000,
                                          isClosable: true,
                                        });
                                      } else {
                                        // Cerrar el toast de progreso y mostrar uno de error
                                        toast.close(toastId);
                                        toast({
                                          title: 'Error',
                                          description:
                                            'No se pudo cancelar el CFDI. Intenta de nuevo.',
                                          status: 'error',
                                          duration: 5000,
                                          isClosable: true,
                                        });
                                      }
                                    } catch (error) {
                                      console.error(
                                        'Error al cancelar el CFDI:',
                                        error,
                                      );

                                      // Cerrar el toast de progreso y mostrar uno de error
                                      toast.close(toastId);
                                      toast({
                                        title: 'Error',
                                        description:
                                          'No se pudo cancelar el CFDI. Intenta de nuevo.',
                                        status: 'error',
                                        duration: 5000,
                                        isClosable: true,
                                      });
                                    }
                                  }}
                                >
                                  Cancelar CFDI
                                </MenuItem>
                              </MenuList>
                            </Menu>
                          </Td>
                        </Tr>
                      ))
                    ) : (
                      <Tr>
                        <Td colSpan={6} textAlign="center">
                          No hay pagos registrados.
                        </Td>
                      </Tr>
                    )}
                  </Tbody>
                </Table>
              </Box>
            )}
          </TabPanel>
        </TabPanels>
      </Tabs>

      {/* Modal para Ver Detalle */}
      <Modal isOpen={isDetailOpen} onClose={onDetailClose} size="6xl">
        <ModalOverlay />
        <ModalContent>
          <ModalCloseButton />
          <ModalBody>
            {selectedPagoId && (
              <TransaccionDetails transaccionId={selectedPagoId} />
            )}
          </ModalBody>
          <ModalFooter>
            <Button variant="ghost" onClick={onDetailClose}>
              Cerrar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Box>
  );
};

export default HistorialPagos;
